import {
  PolicyContainerApp,
  PolicyTitle,
  PolicyText,
  PolicyList,
  PolicySectionTitle,
  PolicyArticleTitle,
  PolicyHyphenList,
} from "styles/PolicyCommon";

const StudioWeeks21 = () => {
  return (
    <PolicyContainerApp>
      <h1 className="hide">열달후에</h1>
      <PolicyTitle>개인정보 수집∙이용 및 제3자 제공 동의</PolicyTitle>

      <PolicySectionTitle>
        □ 개인정보의 수집∙이용에 관한 사항
      </PolicySectionTitle>
      <PolicyText>
        주식회사 커넥트아이 (이하“회사”)는 「개인정보보호법」, 「신용정보의 이용
        및 보호에 관한 법률」, 「정보통신망 이용촉진 및 정보보호 등에 관한
        법률」 등 관련 법규에 따라 귀하의 개인 정보를 다음과 같이
        수집∙이용하고자 합니다.
      </PolicyText>

      <PolicySectionTitle>
        □ 개인정보의 수집∙이용 목적 및 항목
      </PolicySectionTitle>
      <PolicyList>
        <li>
          수집 목적 :
          <PolicyHyphenList>
            <li>지역 맞춤 스튜디오 무료 촬영 안내</li>
          </PolicyHyphenList>
        </li>
        <li>
          수집 항목 : 성명, 휴대폰번호, 이메일(아이디), 생년월일, 출산예정일,
          지역정보
        </li>
        <li>보유 및 이용 기간 : 1년</li>
      </PolicyList>

      <PolicySectionTitle>
        □ 개인정보의 제3자 제공에 관한 사항
      </PolicySectionTitle>
      <PolicyText>
        회사는 「개인정보보호법」, 「신용정보의 이용 및 보호에 관한 법률」,
        「정보통신망 이용촉진 및 정보보호 등에 관한 법률」 등 관련 법규에 따라
        귀하의 개인정보를 다음과 같이 제3자에게 제공하고자 합니다.
      </PolicyText>

      <PolicySectionTitle>
        □ 개인(신용)정보를 제공받는 자의 이용 목적 및 항목
      </PolicySectionTitle>
      <PolicyArticleTitle>지역 맞춤 스튜디오 무료 촬영 안내</PolicyArticleTitle>
      <PolicyList>
        <li>
          제공받는 자 : 애니스튜디오 및 지역별 애니 스튜디오 가맹점 (설정한 대표
          지역에 속하는 스튜디오에만 정보가 제공되며, 해당 지역과 인접한
          스튜디오가 없는 경우에는 정보가 제공되지 않습니다.)
          <PolicyHyphenList>
            <li>
              애니스튜디오 광진점, 도봉점, 안양본점, 부산점, 대구점, 서구점,
              연수점, 강릉점, 창원점, 진주점, 김해점, 아이톡 스튜디오,
              파스텔스튜디오 대전점
            </li>
          </PolicyHyphenList>
        </li>
        <li>제공받는 목적 : 지역 맞춤 스튜디오 무료촬영 안내</li>
        <li>
          제공받는 항목 : 성명, 이메일(아이디), 생년월일, 출산예정일,
          휴대전화번호, 지역정보
        </li>
        <li>보유 및 이용 기간 : 1년</li>
      </PolicyList>

      <PolicySectionTitle>
        □ 동의를 거부하는 경우에 대한 안내
      </PolicySectionTitle>
      <PolicyText>
        "열달후에 서비스의 혜택인 지역 맞춤 스튜디오 무료 촬영 안내"를 위한
        필수적인 동의이므로, 동의를 하지 않으면 해당 서비스를 이용하실 수
        없습니다.
      </PolicyText>

      <PolicySectionTitle>□ 동의 철회를 위한 안내</PolicySectionTitle>
      <PolicyText>
        본 동의를 하시더라도 앱 내 마이메뉴&gt;1:1문의 또는 당사
        고객센터(after10month@connect-i.co.kr)를 통해 동의를 철회하거나 가입
        안내 목적의 연락에 대한 중단을 요청하실 수 있습니다.
      </PolicyText>
    </PolicyContainerApp>
  );
};

export default StudioWeeks21;
